import axios from 'axios'
import type { DatExecutorPoolSnapshot, LiveDatSearchConfigDto, LiveDatSearchSettingsResponse, LiveDatUsageResponse } from '@numeo/types-core'

interface Envelope<T> {
    success: boolean
    data: T
    message?: string
}

export type { LiveDatSearchConfigDto }

export type LiveDatSearchSettings = LiveDatSearchSettingsResponse

export const liveDatSearchApi = {
    async get(): Promise<LiveDatSearchSettings> {
        const response = await axios.get<Envelope<LiveDatSearchSettings>>('/gluon/live-dat-search')
        return response.data.data
    },

    async save(config: LiveDatSearchConfigDto): Promise<LiveDatSearchConfigDto> {
        const response = await axios.put<Envelope<{ config: LiveDatSearchConfigDto }>>('/gluon/live-dat-search', config)
        return response.data.data.config
    },

    async usage(fromDay: string, toDay: string): Promise<LiveDatUsageResponse> {
        const response = await axios.get<Envelope<LiveDatUsageResponse>>('/gluon/live-dat-search/usage', { params: { fromDay, toDay } })
        return response.data.data
    },

    async executors(): Promise<DatExecutorPoolSnapshot> {
        const response = await axios.get<Envelope<DatExecutorPoolSnapshot>>('/gluon/live-dat-search/executors/v1')
        return response.data.data
    },
}
